import React, { useEffect, useState, useRef } from 'react';
import ChatHistoryList from './ChatHistoryList';
import styled from 'styled-components';
import HeaderWithBack from '../../../components/HeaderWithBack';
import BottomNav from '../../../components/BottomNav';
import { useLocation } from 'react-router-dom';
import axios from '../../../api/axios';

const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
`;

const MessagesContainer = styled.div`
  flex: 1;
  padding: 0 16px 10px; 
  overflow-y: auto;
  background-color: #f5f5f5;
`;

interface ChatProps {
  userId: string | null;
  username: string | null;
  conversationID: string;  
  conversationType: number; 
}

const ChatHistories: React.FC<ChatProps> = ({ userId, username, conversationID, conversationType }) => {
  const location = useLocation();
  const profileName = location.state?.profileName || null; 
  const messagesEndRef = useRef<HTMLDivElement | null>(null); 
  const messagesContainerRef = useRef<HTMLDivElement | null>(null); 

  const storedData = sessionStorage.getItem('userData');
  const userData = storedData ? JSON.parse(storedData) : null;
  const token = userData ? userData.token : null;
  const [teleconsult, setTeleconsult] = React.useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`list-chat-histories`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });

        const data = response.data;
        setTeleconsult(data);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    
    fetchData(); 
  }, [token]);

  return (
    <div
        style={{
            fontFamily: "Arial, sans-serif",
            minHeight: "100vh",
            paddingBottom: "60px",
        }}
        >
        
      <HeaderWithBack title="Chat Histories" />
        <ChatContainer>
          <MessagesContainer
            ref={messagesContainerRef}
          >
            <ChatHistoryList 
              userId={userId}
              username={username}
              conversationID={conversationID}
              conversationType={conversationType}
              profileName={profileName}
              teleconsults={teleconsult?.data ?? []}  
            />
            <div ref={messagesEndRef} /> 
          </MessagesContainer>
        </ChatContainer>
      <BottomNav/>
    </div>
  );
};

export default ChatHistories;
